import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Landmark, TrendingUp, CalendarClock, ShieldCheck, Globe, ChevronRight } from "lucide-react";

const iconMap = { Landmark, TrendingUp, CalendarClock };

export default function Hero({ onOpenAccount }) {
  const hero = useContent().hero;
  return (
    <section id="top" className="relative pt-28 lg:pt-36 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Left */}
        <div>
          <div className="eyebrow mb-5">{hero.eyebrow}</div>
          <h1 className="font-serif-lux text-5xl lg:text-[64px] leading-[1.05] text-[#16233d] font-semibold">
            {hero.titlePre} <span className="text-[#b08d57] italic">{hero.titleAccent}</span> {hero.titlePost}
          </h1>
          <p className="mt-6 text-[#5c6577] text-lg leading-relaxed max-w-xl">{hero.text}</p>

          <div className="mt-6 flex items-start gap-2.5 text-[#3a4258] text-sm">
            <Globe size={18} className="text-[#b08d57] mt-0.5 shrink-0" />
            <span>{hero.network}</span>
          </div>

          <div className="mt-5 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#e7e2d8] bg-[#faf8f4] px-4 py-2 text-xs text-[#3a4258]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#b08d57]" /> {hero.badge1}
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#e7e2d8] bg-[#faf8f4] px-4 py-2 text-xs text-[#3a4258]">
              <ShieldCheck size={14} className="text-[#b08d57]" /> {hero.badge2}
            </span>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <button onClick={onOpenAccount} className="btn-gold rounded-md px-6 py-3.5 font-medium flex items-center gap-2">
              {hero.btnOpen} <ChevronRight size={18} />
            </button>
            <a href="#konditionen" className="btn-outline-navy rounded-md px-6 py-3.5 font-medium">{hero.btnConditions}</a>
            <a href="#vermoegen" className="btn-outline-navy rounded-md px-6 py-3.5 font-medium">{hero.btnAdvice}</a>
          </div>
        </div>

        {/* Right image */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_40px_80px_-40px_rgba(22,35,61,0.4)]">
            <img src={hero.image} alt="Beratung" className="w-full h-[560px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl border border-[#f0ece3] p-5 max-w-[280px]">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-lg bg-[#faf3e8] flex items-center justify-center">
                <ShieldCheck size={22} className="text-[#b08d57]" />
              </div>
              <div>
                <div className="text-[13px] text-[#3a4258] leading-snug">{hero.floatGuarantee}</div>
              </div>
            </div>
          </div>
          <div className="absolute -top-5 -right-5 bg-[#16233d] text-white rounded-xl shadow-xl px-5 py-4 hidden sm:block">
            <div className="font-serif-lux text-3xl text-[#d3b077] leading-none">4,25%</div>
            <div className="text-[11px] text-white/70 mt-1">{hero.floatRateLabel}</div>
          </div>
        </div>
      </div>

      {/* trust bar */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
        <div className="grid sm:grid-cols-3 gap-6 border-t border-[#eee] pt-8">
          {hero.stats.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.label} className="flex items-center gap-3">
                <Icon size={20} className="text-[#b08d57]" />
                <span className="text-sm text-[#3a4258]">{s.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
